/**
 * This library gathers the variables available in project descriptor scripts,
 * and exposed in the app code editor
 */

import * as model from 'ca/model';
import * as spatial from 'ca/spatial';
import * as waterflow from 'ca/waterflow';
import * as utils from 'utils/image';

export { model };
export { spatial };
export { utils };
export { waterflow };